__turbopack_context__.v({
  "animateDown": "SlideableDrawer-module__F-5Xkq__animateDown",
  "animateDownToBanner": "SlideableDrawer-module__F-5Xkq__animateDownToBanner",
  "animateUp": "SlideableDrawer-module__F-5Xkq__animateUp",
  "animateUpFromBanner": "SlideableDrawer-module__F-5Xkq__animateUpFromBanner",
  "bannerContainer": "SlideableDrawer-module__F-5Xkq__bannerContainer",
  "bannerContainerClickable": "SlideableDrawer-module__F-5Xkq__bannerContainerClickable",
  "bannerContainerCollapsed": "SlideableDrawer-module__F-5Xkq__bannerContainerCollapsed",
  "bannerContainerHidden": "SlideableDrawer-module__F-5Xkq__bannerContainerHidden",
  "bannerOpen": "SlideableDrawer-module__F-5Xkq__bannerOpen",
  "bannerSubtitle": "SlideableDrawer-module__F-5Xkq__bannerSubtitle",
  "bannerText": "SlideableDrawer-module__F-5Xkq__bannerText",
  "completelyHidden": "SlideableDrawer-module__F-5Xkq__completelyHidden",
  "container": "SlideableDrawer-module__F-5Xkq__container",
  "containerBanner": "SlideableDrawer-module__F-5Xkq__containerBanner",
  "containerFullHeight": "SlideableDrawer-module__F-5Xkq__containerFullHeight",
  "dismissContainer": "SlideableDrawer-module__F-5Xkq__dismissContainer",
  "dismissContainerBanner": "SlideableDrawer-module__F-5Xkq__dismissContainerBanner",
  "down": "SlideableDrawer-module__F-5Xkq__down",
  "downToBanner": "SlideableDrawer-module__F-5Xkq__downToBanner",
  "overlay": "SlideableDrawer-module__F-5Xkq__overlay",
  "overlayBlur": "SlideableDrawer-module__F-5Xkq__overlayBlur",
  "overlayHidden": "SlideableDrawer-module__F-5Xkq__overlayHidden" + " " + "SlideableDrawer-module__F-5Xkq__overlay",
  "up": "SlideableDrawer-module__F-5Xkq__up",
  "upFromBanner": "SlideableDrawer-module__F-5Xkq__upFromBanner",
});
